module.exports = __webpack_public_path__ + "img/yundesk-banner.8be30bd2.png";